import React from 'react';
import { Brain, Zap, RefreshCw } from 'lucide-react';
export function ScienceSection() {
  return <section id="why-section" className="relative w-full py-14 px-4 bg-navy scroll-mt-10" data-id="element-243">
      {/* Blueprint Grid Texture Overlay */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(#C9A84C 1px, transparent 1px), linear-gradient(90deg, #C9A84C 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-244"></div>

      <div className="relative z-10 max-w-6xl mx-auto flex flex-col items-center" data-id="element-245">
        <p className="text-gold text-sm tracking-[0.2em] uppercase mb-6 font-medium text-center" data-id="element-246">
          THE SCIENCE BEHIND THE PROTOCOL
        </p>

        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-cream text-center max-w-3xl leading-tight mb-8" data-id="element-247">
          This Isn't Spirituality vs. Science.
          <br data-id="element-248" />
          <span className="italic" data-id="element-249">It's Both — And Here's Why It Works.</span>
        </h2>

        <p className="text-lg text-cream/80 text-center max-w-2xl mb-16" data-id="element-250">
          The 417hz Solfeggio Frequency has been studied in the context of
          nervous system regulation and emotional trauma release. Here is what
          the research suggests:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full mb-12" data-id="element-251">
          {/* Card 1 */}
          <div className="bg-navy-dark border border-gold/30 rounded-xl p-8 flex flex-col items-center text-center hover:border-gold transition-colors duration-300" data-id="element-252">
            <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center mb-6" data-id="element-253">
              <Brain className="w-8 h-8 text-gold" data-id="element-254" />
            </div>
            <h3 className="font-serif text-2xl text-cream mb-4" data-id="element-255">
              The Nervous System Reset
            </h3>
            <p className="text-cream/70 leading-relaxed" data-id="element-256">
              Studies in psychoacoustics show that specific sound frequencies
              can shift the brain from a high-stress beta state into a
              restorative alpha or theta state within minutes — the same state
              associated with creativity, openness, and 'lucky' decision-making.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-navy-dark border border-gold/30 rounded-xl p-8 flex flex-col items-center text-center hover:border-gold transition-colors duration-300" data-id="element-257">
            <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center mb-6" data-id="element-258">
              <Zap className="w-8 h-8 text-gold" data-id="element-259" />
            </div>
            <h3 className="font-serif text-2xl text-cream mb-4" data-id="element-260">
              The Bioelectric Field
            </h3>
            <p className="text-cream/70 leading-relaxed" data-id="element-261">
              The human body generates a measurable electromagnetic field
              (studied in the field of bioelectromagnetics). Chronic emotional
              stress, conflict exposure, and anxiety have been shown to create
              measurable disruptions in this field — what energy workers call
              'interference.'
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-navy-dark border border-gold/30 rounded-xl p-8 flex flex-col items-center text-center hover:border-gold transition-colors duration-300" data-id="element-262">
            <div className="w-16 h-16 rounded-full bg-gold/10 flex items-center justify-center mb-6" data-id="element-263">
              <RefreshCw className="w-8 h-8 text-gold" data-id="element-264" />
            </div>
            <h3 className="font-serif text-2xl text-cream mb-4" data-id="element-265">
              The Pattern Interruption
            </h3>
            <p className="text-cream/70 leading-relaxed" data-id="element-266">
              Cognitive behavioral research confirms that repetitive negative
              thought loops ('Why does this always happen to me?') keep the
              brain locked in a threat-detection mode — literally making it
              harder to notice opportunities. The scripting component of this
              protocol is designed to break this loop.
            </p>
          </div>
        </div>

        <p className="text-xs text-cream/40 text-center max-w-3xl italic" data-id="element-267">
          *The Lucky Flush Protocol is not a medical treatment. The frequency
          and scripting tools are designed for emotional wellness and mindset
          support only.
        </p>
      </div>
    </section>;
}